module.exports = __webpack_public_path__ + "img/7.c91ff876.png";